import React from "react";

const NotFound = () => {
  return (
    <div className="main-box">
      <div className="page-not-found">
        <h2>
          4
          <svg
            width="200"
            height="200"
            viewBox="0 0 200 200"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_638_336)">
              <path
                d="M183.109 83.7833C183.111 76.295 182.225 68.8329 180.469 61.5533C175.558 51.3153 168.746 42.1557 160.497 34.5286C145.368 25.4906 127.547 20.5649 108.624 21.2554C56.4154 23.1582 15.6358 67.025 17.5386 119.233C17.8096 126.702 18.9633 134.112 20.9758 141.31C25.2197 149.392 30.6732 156.779 37.1476 163.215C51.9397 172.803 69.5737 178.378 88.5152 178.378C140.757 178.378 183.109 136.026 183.109 83.7833ZM133.561 66.8912C139.531 66.8912 144.372 71.7318 144.372 77.7021C144.372 83.6725 139.531 88.5131 133.561 88.5131C127.591 88.5131 122.75 83.6725 122.75 77.7021C122.75 71.7318 127.591 66.8912 133.561 66.8912ZM66.6683 66.8912C72.6386 66.8912 77.4793 71.7318 77.4793 77.7021C77.4793 83.6725 72.6386 88.5131 66.6683 88.5131C60.6979 88.5131 55.8573 83.6725 55.8573 77.7021C55.8573 71.7318 60.6979 66.8912 66.6683 66.8912ZM59.4337 145.54L50.8978 138.904C65.3852 120.27 89.6767 111.352 112.782 116.18C127.148 119.185 140.048 127.256 149.104 138.904L140.569 145.54C133.084 135.912 122.429 129.243 110.569 126.763C91.4767 122.77 71.4042 130.141 59.4337 145.54Z"
                fill="#FFCE00"
              />
              <path
                d="M180.467 61.5527C182.222 68.8324 183.108 76.2945 183.107 83.7828C183.107 136.025 140.755 178.377 88.5121 178.377C69.5713 178.377 51.9366 172.802 37.1445 163.215C53.2799 179.258 75.5005 189.188 99.9988 189.188C149.178 189.188 189.188 149.178 189.188 99.9992C189.188 86.2409 186.054 73.2009 180.467 61.5527Z"
                fill="#FFB100"
              />
              <path
                d="M108.625 21.2546C127.548 20.5647 145.369 25.4898 160.498 34.5278C144.588 19.8161 123.328 10.8105 100.002 10.8105C50.8225 10.8105 10.8125 50.8206 10.8125 99.9996C10.8125 114.898 14.4896 128.952 20.9762 141.31C18.9637 134.112 17.81 126.702 17.5389 119.233C15.6362 67.0248 56.4158 23.158 108.625 21.2546Z"
                fill="#FFE454"
              />
              <path
                d="M100 0C44.8601 0 0 44.8601 0 100C0 155.14 44.8601 200 100 200C155.14 200 200 155.14 200 100C200 44.8601 155.14 0 100 0ZM100 189.189C75.5017 189.189 53.2811 179.259 37.1458 163.216C30.6715 156.78 25.2181 149.393 20.9739 141.31C14.488 128.952 10.811 114.898 10.811 100C10.811 50.821 50.821 10.811 100 10.811C123.327 10.811 144.586 19.8165 160.496 34.5288C168.745 42.156 175.556 51.3156 180.468 61.5535C186.056 73.2017 189.189 86.2417 189.189 100C189.189 149.179 149.179 189.189 100 189.189Z"
                fill="black"
              />
              <path
                d="M110.57 126.764C122.43 129.244 133.085 135.913 140.57 145.541L149.105 138.905C140.049 127.257 127.149 119.186 112.782 116.181C89.6773 111.353 65.3858 120.271 50.8984 138.905L59.4344 145.541C71.4048 130.142 91.4774 122.771 110.57 126.764Z"
                fill="black"
              />
              <path
                d="M66.6664 88.5125C72.6372 88.5125 77.4774 83.6723 77.4774 77.7016C77.4774 71.7309 72.6372 66.8906 66.6664 66.8906C60.6957 66.8906 55.8555 71.7309 55.8555 77.7016C55.8555 83.6723 60.6957 88.5125 66.6664 88.5125Z"
                fill="black"
              />
              <path
                d="M133.561 88.5125C139.532 88.5125 144.372 83.6723 144.372 77.7016C144.372 71.7309 139.532 66.8906 133.561 66.8906C127.59 66.8906 122.75 71.7309 122.75 77.7016C122.75 83.6723 127.59 88.5125 133.561 88.5125Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_638_336">
                <rect width="200" height="200" fill="white" />
              </clipPath>
            </defs>
          </svg>
          4
        </h2>
        <p>Page not found</p>
      </div>
    </div>
  );
};

export default NotFound;
